var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVirtualtour = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 10V4.625C14 4.00391 13.4961 3.5 12.875 3.5H10.8125L10.5219 2.72891C10.3578 2.29062 9.93828 2 9.46953 2H6.52812C6.05937 2 5.63984 2.29062 5.47578 2.72891L5.1875 3.5H3.125C2.50391 3.5 2 4.00391 2 4.625V9.88227C3.24007 10.7525 4.81209 11.3247 6.49486 11.5435C5.62557 10.9948 5 10.0197 5 9C5 7.44844 6.44844 6 8 6C9.55156 6 11 7.44844 11 9C11 10.0288 10.3632 11.0123 9.48172 11.5582C11.0569 11.3694 12.618 10.8638 14 10ZM8 11C9.13672 11 10 10.1367 10 9C10 7.86328 9.13672 7 8 7C6.86328 7 6 7.86328 6 9C6 10.1367 6.86328 11 8 11Z",
    fill: "#005E7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85177 12.4618V13.0956C6.66667 13.0851 6.48261 13.07 6.29856 13.0519L6.02039 13.0218C4.55111 12.8427 3.20837 12.4091 2.24 11.7994C1.62405 11.4125 0.889935 10.7832 0.889935 9.99285C0.889935 9.34701 0.989673 8.8854 1.5 8.5V7C0.558824 7.60218 0 8.56116 0 9.98833C0 11.6669 1.29359 12.6982 2.37909 13.2642L2.44601 13.2973C3.51895 13.8438 4.85124 14.2006 6.29752 14.3361C6.48052 14.3527 6.66458 14.3662 6.85072 14.3767V15L7.39974 14.3978L8 13.7339L7.44157 13.1167L6.85177 12.4618Z",
    fill: "#005E7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7.5V9C15.0189 9.36586 15.0962 9.72376 15.0962 10.3369C15.0962 11.0915 14.3518 11.6889 13.7234 12.0519C12.7387 12.6235 11.3734 13.0423 9.87939 13.2123C9.59335 13.2452 9.30305 13.2681 9.0117 13.2824L9.59654 13.8855L9 14.5C10.695 14.42 12.2751 14.0627 13.5128 13.4739L13.5798 13.4424C14.6836 12.9036 16 11.9261 16 10.3326C16 8.9806 15.4623 8.07309 14.5 7.5Z",
    fill: "#005E7A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVirtualtour);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/virtualtour.4c99d293065d3c3bcd2fef07410b8722.svg";